<template>
  <div class="md:mx-4 lg:mx-4 text-dark">
    <div class="text-center ">
      <div class="flex items-center justify-center">
      </div>

      <img src="@/assets/images/improvee_ai.svg" alt="Image" class="mx-auto mb-4 w-2/3">


      <h5 class="font-bold aicolor">improvee.io AI coach</h5>

      <h1 class=" font-black text-black">embrace your potential</h1>

      <p class="mt-2">improvee.io AI is a cutting-edge platform that uses AI technology to help people improve their lives.</p>

    <vs-collapse class="mt-4">
        <vs-collapse-item >
          <div slot="header" class="flex items-center text-sm">
            <feather-icon icon="YoutubeIcon" class="mr-2 w-5" />
            <span class="">video introduction</span>
          </div>


          <youtube class="track-ai-video mt-4" video-id="V6mkp7bBARo" :player-width="playerWidth"></youtube>

      </vs-collapse-item>

      <vs-collapse-item >
          <div slot="header" class="flex items-center text-sm">
            <feather-icon icon="SettingsIcon" class="mr-2 w-5" />
            <span class="">settings</span>
          </div>

      <!--  <p class="mt-2">
         <span >Our AI system</span> is designed to provide personalized advice and guidance to help people become their best selves.

               <span class="font-bold">To get the most value from AI coach, it's essential to provide it with as much understandable data as you can.</span>
              </p> -->

        <div class="text-sm flex">
         <vs-checkbox class="mb-4" name="dont-wanat-tips" color="danger" id="dont-wanat-tips" v-model="dontWantTips" @change="updateDisableAiCoach">
            I don't want to receive tips from improvee.io AI
         </vs-checkbox>
        </div>
         <span class="text-xs font-italic">Improvee.io AI coach has been proven to increase productivity by up to 25%, reduce stress, and help individuals achieve their goals faster and more effectively</span>
      </vs-collapse-item>

    </vs-collapse>


    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      dontWantTips: null
    }
  },
  watch: {
  },
  computed: {
    playerWidth () {
      return this.$store.getters.isMobile ? 350 : 500
    }
  },
  methods: {
    updateDisableAiCoach () {
      this.$store.dispatch('ADDITIONAL_USER_INFO', { aiTipsDisabled: this.dontWantTips })
    },
    iAmInterested () {
      this.$store.dispatch('ADDITIONAL_USER_INFO', { interestedInReferral: true })
    }
  }
}
</script>
